import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { updateBrokerGross } from 'bundles/apex/pipeline/settings/store/actions';

import ManagedInput from 'components/form/managed_input';
import { brokerGrossOptions } from '../config';

export function BrokerGrossSettings({ viewConfig, updateBrokerGross }) {
  return (
    <div className="broker-gross">
      <h3 className="mt-0 mb-2">Broker / Brokerage Gross</h3>
      <ManagedInput
        inline={false}
        options={brokerGrossOptions}
        type="radioGroup"
        value={viewConfig.brokerGross}
        onValueChange={value => updateBrokerGross(value)}
      />
    </div>
  );
}

BrokerGrossSettings.propTypes = {
  updateBrokerGross: PropTypes.func.isRequired,
  viewConfig: PropTypes.shape({
    brokerGross: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  viewConfig: state.view,
});

const mapDispatchToProps = {
  updateBrokerGross,
};

export default connect(mapStateToProps, mapDispatchToProps)(BrokerGrossSettings);
